<div class="status-signal" [ngClass]="{ 'status-signal--active': active }">
  <div
    class="status-signal__symbol"
    appTooltipPosition="above"
    [appTooltip]="tooltip"
    [appTooltipDisabled]="!tooltip"
  ></div>
  <div class="status-signal__label" *ngIf="label">{{ label }}</div>
</div>
